import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

import InputMask from 'react-input-mask'
import Button from '../Form/Button'

export default class PAF extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ficha: { tipo: '', info: '' }, list: [] }
    }

    busca(e) {
        const ficha = this.state.ficha
        const url = '/api/paf/busca'
        axios.post(url, ficha)
            .then(resp => {
                this.setState({ list: resp.data })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <div className="form-group row text-left">
                        <div className="principal">Tipo:</div>
                        <select className="input" style={{ width: "20vw" }}
                            name="tipo"
                            onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="CPF">Pessoa Física</option>
                            <option value="CNPJ">Pessoa Jurídica</option>
                        </select>
                        {this.renderTipo()}
                    </div>
                    <button onClick={e => this.busca(e)} className='botaoEnviar'>Buscar</button>
                    <div className="container mx-auto">
                        <div className="text-center mx-auto">
                            <table className="table mt-4">
                                <thead>
                                    <tr>
                                        <th>ESTABELECIMENTO</th>
                                        <th>DATA DE CRIAÇÃO</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRows()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderTipo() {
        if (this.state.ficha.tipo == "CPF") {
            return (
                <React.Fragment>
                    <div className="principal">CPF:</div>
                    <InputMask type="text" className="input" style={{ width: "20vw" }}
                        mask="999.999.999-99"
                        name="info"
                        onChange={e => this.updateField(e)} />
                </React.Fragment>
            )
        } else if (this.state.ficha.tipo == "CNPJ") {
            return (
                <React.Fragment>
                    <div className="principal">CNPJ:</div>
                    <InputMask type="text" className="input" style={{ width: "20vw" }}
                        mask="99.999.999/9999-99"
                        name="info"
                        onChange={e => this.updateField(e)} />
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderRows() {
        if (this.state.loaded) {
            let ano = this.state.list.createdAt.slice(0, 4)
            let mes = this.state.list.createdAt.slice(5, 7)
            let dia = this.state.list.createdAt.slice(8, 10)
            var data = dia + "/" + mes + "/" + ano
            return (
                <tr key={this.state.list.cpfCnpj}>
                    <td>{this.state.list.estabelecimento}</td>
                    <td>{data}</td>
                    <td>
                        <Link to={`/documentosEstabelecimento/${this.state.list._id}`} target="_blank" params={this.state.list}>
                            <button className="botaoEnviar" style={{backgroundColor: "#ffc107"}}>Abrir</button>
                        </Link>
                        {this.renderEdit(this.state.list._id)}
                    </td>
                </tr>
            )
        }
    }

    renderEdit(id) {
        if (localStorage.tipo == "interno") {
            return (
                <Link to={`/editCnpj/${id}`} target="_blank" params={this.state.list}>
                    <button className="botaoEnviar">Editar</button>
                </Link>
            )
        } else {
            return <div></div>
        }
    }
}